import { useSelector } from "react-redux";
import IMDocumentTableT3 from "./T3/IMDocumentTable-T3";
import { RootState } from "@/store";
import { UserTierType } from "@/constants/enums/user-tier-type.enum";
import IMDocumentTableT1T2 from "./T1&T2/IMDocumentTable-T1-T2";

interface IMDocumentsProps {
  tabId: number;
}

const IMDocuments = ({ tabId }: IMDocumentsProps) => {
  const user = useSelector((state: RootState) => state.auth.user);
  return (
    <div>
      {(user?.user_type.id === UserTierType.Tier1 ||
        user?.user_type.id === UserTierType.Tier2) && (
        <IMDocumentTableT1T2 tabId={tabId} />
      )}
      {user?.user_type.id === UserTierType.Tier3 && (
        <IMDocumentTableT3 tabId={tabId} />
      )}
    </div>
  );
};

export default IMDocuments;
